import styles from "./styles.module.css";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { Button } from "@mui/material";

export default function ShiftExpiryDialog({ open, onSkip, onCreateNewShift }) {
  if (!open) return null;

  return (
    <div className={styles.popUp}>
      <div className={styles.contentWrapper}>
        <div className={styles.headInfoSec}>
          <h2>Shift Period Warning</h2>
          <CloseRoundedIcon onClick={onSkip} className={styles.icon} />
        </div>

        <div className={styles.contentArea}>
          <h3 className={styles.subTitle}>
            The current shift is older than 1 day. Would you like to create a new shift now?
          </h3>
        </div>

        <div className={styles.buttonSection}>
          <Button onClick={onSkip} className={styles.buttonGray}>
            Skip
          </Button>
          <Button onClick={onCreateNewShift} className={styles.buttonRed}>
            Create New Shift
          </Button>
        </div>
      </div>
    </div>
  );
}
